import React from "react";

const Weather = props => (
  <div className="weather_data">
    <div className="weather_title">
      <h1> {props.data.name} </h1>
      <h3> {props.data.weather[0].main} </h3>
      <p> {props.data.weather[0].description} </p>
    </div>
    <div className="weather_status">
      <ul>
        <li>
          Temp : <span> {props.data.main.temp}° </span>
        </li>
        <li>
          Humidity : <span>{props.data.main.humidity}%</span>
        </li>
        <li>
          Wind : <span>{props.data.wind.speed}km/s</span>
        </li>
      </ul>
    </div>
  </div>
);

export default Weather;
 